module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/selected-for-sale-property-pin-705a4871408c44a3c655587d8ca68998.svg";